export default __webpack_public_path__ + "static/media/crypto bee.123f608b.svg";